import StaffType from "../../../components/staffModule/staffType/StaffType"

function StaffTypePage() {
    return (
        <>
            <StaffType />
        </>
    )
}
export default StaffTypePage